export function ChatIcon() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_561_24211)">
        <path
          d="M8.50158 5.9417C8.50158 5.78003 8.50158 5.6992 8.52588 5.62724C8.59643 5.41791 8.78286 5.33708 8.96976 5.25204C9.17909 5.15625 9.28375 5.10859 9.38795 5.10018C9.50569 5.09084 9.62391 5.11607 9.72483 5.17261C9.85847 5.24737 9.95192 5.39035 10.0472 5.50622C10.4878 6.04169 10.7084 6.30942 10.7888 6.60425C10.8542 6.84255 10.8542 7.09206 10.7888 7.32989C10.6715 7.76069 10.3 8.12141 10.0248 8.45596C9.88417 8.6265 9.81361 8.71201 9.72483 8.76201C9.62217 8.81894 9.50493 8.84414 9.38795 8.83443C9.28375 8.82602 9.17909 8.77836 8.96929 8.68257C8.78239 8.59753 8.59643 8.5167 8.52588 8.30737C8.50158 8.23542 8.50158 8.15458 8.50158 7.99292V5.9417ZM3.8291 5.9417C3.8291 5.73798 3.82349 5.55528 3.65902 5.41231C3.59921 5.36044 3.51978 5.32446 3.36139 5.25204C3.15159 5.15672 3.04693 5.10859 2.94273 5.10018C2.63108 5.07495 2.46333 5.28802 2.28391 5.50669C1.84283 6.04169 1.62229 6.30942 1.54145 6.60472C1.47642 6.84223 1.47642 7.09285 1.54145 7.33036C1.6592 7.76069 2.03113 8.12188 2.30587 8.45596C2.47922 8.66622 2.64509 8.85826 2.94273 8.83443C3.04693 8.82602 3.15159 8.77836 3.36139 8.68257C3.52025 8.61062 3.59921 8.57417 3.65902 8.52231C3.82349 8.37933 3.8291 8.19664 3.8291 7.99338V5.9417Z"
          stroke="currentColor"
          strokeWidth="0.700872"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.89404 5.09841C2.89404 3.54995 4.3584 2.29492 6.16478 2.29492C7.97116 2.29492 9.43551 3.54995 9.43551 5.09841M9.43551 8.83639V9.21019C9.43551 10.0358 8.59914 10.7054 7.56652 10.7054H6.63203"
          stroke="currentColor"
          strokeWidth="0.700872"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_561_24211">
          <rect
            width="11.2139"
            height="11.2139"
            fill="white"
            transform="translate(0.558594 0.893066)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
